export default __webpack_public_path__ + "static/media/Mani-Terminos.fe93a487.png";